import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd570f30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-not-found-view flex-centered col-12 py-4" }
const _hoisted_2 = { class: "d-flex col-12 flex-column text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h1 mb-md-3 mb-4" }, "404 - Page Not Found", -1))

import { useHead } from "@unhead/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageNotFoundView',
  setup(__props) {

useHead({
  title: "Page Not Found",
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: { name: 'Home' },
          class: "btn btn-tertiary text-white text-uppercase"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Go home")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})